import { Injectable } from '@angular/core';
import { CreditNoteDataService } from '@app/core';
import { Resolve } from '@angular/router';

@Injectable()
export class AppDataResolver implements Resolve<any> {
  constructor(private dataService: CreditNoteDataService) {}

  async resolve() {
    return await this.dataService.getPdfData(localStorage.getItem('sfId'), localStorage.getItem('type'));
  }
}
